import { CHECKOUT_STEP, isValidCheckoutStep } from "../constants/checkoutSteps";

export const COUPON_RETURN_STORAGE_KEY = "couponReturnTo";
export const COUPON_RETURN_STEP_KEY = "couponReturnCheckoutStep";
export const COUPON_RETURN_CHECKOUT = "checkout";
export const MY_COUPONS_PATH = "/private-area#coupons";

export const markCouponReturnToCheckout = (
  checkoutStep = CHECKOUT_STEP.DETAILS,
) => {
  try {
    sessionStorage.setItem(COUPON_RETURN_STORAGE_KEY, COUPON_RETURN_CHECKOUT);
    sessionStorage.setItem(COUPON_RETURN_STEP_KEY, String(checkoutStep));
  } catch {
    /* ignore */
  }
};

export const clearCouponReturn = () => {
  try {
    sessionStorage.removeItem(COUPON_RETURN_STORAGE_KEY);
    sessionStorage.removeItem(COUPON_RETURN_STEP_KEY);
  } catch {
    /* ignore */
  }
};

export const getCouponReturnCheckoutStep = () => {
  try {
    const raw = sessionStorage.getItem(COUPON_RETURN_STEP_KEY);
    if (raw == null) return null;
    const step = Number(raw);
    return isValidCheckoutStep(step) ? step : null;
  } catch {
    return null;
  }
};

export const isCouponCheckoutReturn = (location) => {
  const fromState = location?.state?.couponReturnTo;
  if (fromState === COUPON_RETURN_CHECKOUT) return true;

  try {
    return (
      sessionStorage.getItem(COUPON_RETURN_STORAGE_KEY) ===
      COUPON_RETURN_CHECKOUT
    );
  } catch {
    return false;
  }
};

export const parseCheckoutReturnStep = (location) => {
  const fromState = location?.state?.checkoutStep;
  if (isValidCheckoutStep(fromState)) return fromState;

  return getCouponReturnCheckoutStep();
};
